// UN FALLIMENTO MUTO E\' PEGGIO DI UN FALLIMENTO (2026-09-18).
//
// `e.message` e\' vuoto piu\' spesso di quanto sembri: WebCrypto lancia
// OperationError senza testo quando una decifratura non torna, e un
// `throw new Error()` senza argomento fa lo stesso. Chi scriveva
// setError(e.message) mostrava allora una stringa vuota, cioe\' NIENTE: il
// bottone si spegneva e l\'utente restava a guardare. E\' successo davvero
// con i link di condivisione dei file a blocchi, dal 13 al 18 settembre.
//
// Qui si restituisce sempre qualcosa da mostrare: il messaggio vero quando
// c\'e\', altrimenti una frase tradotta che almeno dice che e\' fallito.
export function messaggioErrore(e, t) {
  const testo = e && typeof e.message === 'string' ? e.message.trim() : '';
  if (testo) return testo;
  const nome = e && e.name ? String(e.name) : '';
  const generico = t ? t('errore_senza_messaggio') : 'Something went wrong. Please try again.';
  return nome ? `${generico} (${nome})` : generico;
}
